module.exports = __webpack_public_path__ + "img/icon-about-target-group.b28e9110.svg";